// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__rJ70W","homeVerticalList":"style_homeVerticalList__qwrG1"};